import LocationMarkerIcon from './LocationMarkerIcon';
import {
  LocationMarkerIconWrapper,
  MapLegendSearchAreaContainer,
  MapLegendSearchAreaHeader,
  MapLegendSearchAreaHeaderInnerContainer,
  MapLegendSearchAreaHeaderText,
  MapLegendSearchAreaInputWrapper
} from './MapLegend.styles';
import ZipCodeInput from './ZipCodeInput';

type OwnProps = {
  onSubmit: (searchTerm: string) => void;
  onChange: (searchTerm: string) => void;
  searchTerm: string;
};

export const MapFinderSearchArea = ({
  onSubmit,
  onChange,
  searchTerm
}: OwnProps) => {
  return (
    <MapLegendSearchAreaContainer>
      <MapLegendSearchAreaHeader>
        <MapLegendSearchAreaHeaderInnerContainer>
          <MapLegendSearchAreaHeaderText>
            <LocationMarkerIconWrapper>
              <LocationMarkerIcon />
            </LocationMarkerIconWrapper>
            FIND A VENDING MACHINE NEAR YOU
          </MapLegendSearchAreaHeaderText>
        </MapLegendSearchAreaHeaderInnerContainer>
      </MapLegendSearchAreaHeader>

      <MapLegendSearchAreaInputWrapper>
        <ZipCodeInput
          onSubmit={onSubmit}
          onChange={onChange}
          searchTerm={searchTerm}
          id="zipcode-map"
        />
      </MapLegendSearchAreaInputWrapper>
    </MapLegendSearchAreaContainer>
  );
};
